import { deleteObject } from "firebase/storage";

export const filters=[
    {id : 2 , name:"Jasp",value:'jasp'},
    {id : 3 , name:"Rock",value:'Rock'},
    {id : 4 , name:"Melody ",value:'Melody'},
    {id : 5 , name:"Karoke",value:'Karoke'},
];

export const filterByLanguage=[
    {id:1, name:"Tamil", value:"tamil"},
    {id:2, name:"English", value:"english"},
    {id:3, name:"Malayam", value:"malayam"},
    {id:4, name:"Telegu", value:" telegu"},
    {id:5, name:"Hindi", value:"hindi"},
]

